import React from 'react'
import S from './Flex.styles'
import { FlexComponent } from './types'

const Flex: FlexComponent = ({
  gap = 1,
  direction = 'row',
  align = 'baseline',
  justify = 'flex-start',
  overflow = 'visible',
  wrap = false,
  children,
}) => {
  return (
    <S.Wrapper
      $gap={gap}
      $direction={direction}
      $align={align}
      $justify={justify}
      $overflow={overflow}
      $wrap={wrap ? 'wrap' : 'nowrap'}>
      {children}
    </S.Wrapper>
  )
}

export default Flex
